import classNames from "classnames";
import React, { ReactElement } from "react";

interface Props {
  isControlsVisible: boolean;
  isPlaying: boolean;
  rippleClassName?: string;
  onClickPlayer: () => void;
}

export function PlayerOverlay(props: Props): ReactElement {
  return (
    <>
      {/* Render Blacken */}
      <div
        className={classNames({
          VideoScreen__PlayerOverlayBlacken: true,
          VideoScreen__playerControlsFadeIn: props.isControlsVisible,
          VideoScreen__playerControlsFadeOut: !props.isControlsVisible,
        })}
      />

      {/* Render Ripple */}
      <div className={classNames("VideoScreen__PlayerRipple", props.rippleClassName)} />

      {/* Render Play/Pause buttons */}
      <div
        onClick={props.onClickPlayer}
        className={classNames({
          VideoScreen__playerControlsPlayPause: true,
          VideoScreen__playerControlsPause: props.isPlaying,
          VideoScreen__playerControlsPlay: !props.isPlaying,
          VideoScreen__playerControlsFadeIn: props.isControlsVisible,
          VideoScreen__playerControlsFadeOut: !props.isControlsVisible,
        })}
      />
    </>
  );
}
